module.exports = __webpack_public_path__ + "img/icon6.7f2a4f39.svg";